export default "__VITE_ASSET__DgnCMujI__"